<template>
  <div class="wrapper_patient_card">
    <div class="w3-card w3-row w3-padding">
      <div class="w3-col m6 l3 w3-large">
        <span class="w3-tiny">სახელი</span>
        {{patientData.name}}
      </div>
      <div class="w3-col m6 l3 w3-large">
        <span class="w3-tiny">გვარი</span>
        {{patientData.surname}}
      </div>
      <div class="w3-col m6 l3 w3-large">
        <span class="w3-tiny">ID#</span>
        {{patientData.id_number}}
      </div>
      <div class="w3-col m6 l3 w3-large">
        <span class="w3-tiny">დაბ.თარ.</span>
        {{patientData.date_of_birth}}
      </div>
      <div class="w3-col m12 l9 w3-large">
        <span class="w3-tiny">დაწეს.</span>
        {{getPrisonNameById(patientData.prison_id)}}
      </div>

      <h3></h3>
      <br>
    </div>
    <!-- <div class="w3-tiny">{{patientData}}</div> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "PatientCard",
  props: ["patientData"],
  computed: {
    ...mapGetters(["getPrisonNameById"])
  }
};
</script>

<style>
</style>
